import { AfterViewInit, Component, Input, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'ls-input',
  template: '',
  standalone: true
})
export class LsInputComponent implements OnInit, AfterViewInit {
  @Input() inputId: string = 'input';
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() size: 'sm' | 'md' | 'lg' = 'lg';
  @Input() group!: UntypedFormGroup;
  @Input() controlName!: string;
  @Input() autofocus: boolean = false;

  constructor(
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    // if there is no form control passed,
    // build a generic one to avoid console errors
    if (!this.group) {
      const builder = new UntypedFormBuilder();
      this.group = builder.group({
        [this.controlName]: ['', []],
      });
    }

    if (this.disabled) {
      this.group.controls[this.controlName].disable();
    }
  }

  ngAfterViewInit() {
    if (this.autofocus) {
      this.renderer.selectRootElement('#' + this.inputId).focus();
    }
  }

  get isInvalid(): boolean {
    if (this.group) {
      const control = this.group.controls[this.controlName];
      if (control) {
        return control.touched && control.invalid;
      }
    }
    return false;
  }

  get class(): string[] {
    const invalid = this.isInvalid ? 'invalid' : '';
    return [`input-${this.size} ${invalid}`];
  }
}
